module.exports = __webpack_public_path__ + "fonts/Yekan.1ce443bd.eot";